var _path, _circle, _path2, _circle2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultationRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.267 14.8857C27.267 16.5361 25.9897 18.1847 23.5784 19.459C21.1965 20.7178 17.861 21.516 14.1411 21.516C10.4212 21.516 7.08572 20.7178 4.7038 19.459C2.29253 18.1847 1.01523 16.5361 1.01523 14.8857C1.01523 13.2354 2.29253 11.5868 4.7038 10.3125C7.08572 9.0537 10.4212 8.25547 14.1411 8.25547C17.861 8.25547 21.1965 9.0537 23.5784 10.3125C25.9897 11.5868 27.267 13.2354 27.267 14.8857Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1305,
    cy: 14.8112,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 21.7237C10.7379 19.5966 11.6463 17.9034 12.8928 17.2246M17.6364 21.7237C17.5235 19.5966 16.6085 17.9034 15.359 17.2246",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1305,
    cy: 3.35022,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3584 5.76367C16.2298 6.23702 16.9385 7.20375 17.3259 8.46693M12.8922 5.76367C12.0507 6.22189 11.3633 7.14245 10.9707 8.34671",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationRoom);
export default __webpack_public_path__ + "static/media/ConsultationRoom.62bed4976872066512eb45e0a9fb93e0.svg";
export { ForwardRef as ReactComponent };